import React, { useState } from "react";
import { Sidebar } from "../Sidebar/Sidebar";
import { GridDashBoard } from "../../style/Dashboard";
import { Navbar } from "../Navbar/Navbar";
import {
  Scheduler,
  Appointments,
  WeekView,
  Resources,
} from "@devexpress/dx-react-scheduler-material-ui";
import appointments from "../../data/today";
import {
  CalenderConatainer,
  CustomCalender,
  CustomPaper,
} from "../../style/Calender";
import "./calextended.css";

import { Provider } from "./Provider";
import AdHorizontal from "../../assets/Ads/Horizontal.jpeg";
import AdVertical from "../../assets/Ads/vertical.jpeg";
import { CustomDiv } from "../../style/shared";
import { Logo2 } from "../logo/Logo";
import { render } from "@testing-library/react";
import moment from "moment";
import { grey } from "@material-ui/core/colors";
import { verifyAuth } from "../../authverify";
import AdvertiserCard from "../common/card";
import Mycontext from "../../store/Mycontext";
import MedizenCreative from "../NewCreatives/MedizenCreative/MedizenCreative";
import PrimeraCreative from "../NewCreatives/PrimeraCreative/PrimeraCreative";
import PanazCreative from "../NewCreatives/PanazCreative/PanazCreative";
import MedizenVerticalAd from "../../assets/Ads/MedizenV.jpg";
import PrimeraVerticalAd from "../../assets/Ads/PrimeraV.jpg";
import PanazVerticalAd from "../../assets/Ads/PanazV.jpg";
import { NEW_AD_CREATIVE, NEW_CREATIVE_LOCATION, creativeConstants, htmls } from "../../constants";
import CustomizePopup from "../Home/CustomizePopup";
// config/sidebarConfig.js
import Cal from "../../assets/sidebar/calendar.svg";
import User from "../../assets/sidebar/user.svg";
import Menu from "../../assets/sidebar/menu.svg";
import Person from "../../assets/sidebar/person.svg";
import CalA from "../../assets/sidebar/calendarA.svg";
import UserA from "../../assets/sidebar/userA.svg";
import MenuA from "../../assets/sidebar/menuA.svg";
import PersonA from "../../assets/sidebar/personA.svg";
import TaskIcon from "../../assets/sidebar/tasklist.svg";
import TaskIconA from "../../assets/sidebar/tasklistA.svg";
import { Grid } from "@material-ui/core";
import MobileNavbar from "../MobileNav/MobileNav";

export const sidebarConfig = [
  {
    path: "/Calender",
    icon: Cal,
    activeIcon: CalA,
    alt: "Cal",
  },
  {
    path: "/People/dashboard",
    icon: User,
    activeIcon: UserA,
    alt: "User",
  },
  {
    path: "",
    icon: Menu,
    activeIcon: MenuA,
    alt: "Menu",
  },
  {
    path: "",
    icon: Person,
    activeIcon: PersonA,
    alt: "Person",
  },
  {
    path: "/TaskList",
    icon: TaskIcon,
    activeIcon: TaskIconA,
    alt: "TaskList",
  },
];



//const [value, onChange] = React.useState(new Date());
const loginAds = {
  1: <MedizenCreative />,
  2: <PrimeraCreative />,
  3: <PanazCreative />,
};

const loginAds1 = {
  1: MedizenVerticalAd,
  2: PrimeraVerticalAd,
  3: PanazVerticalAd,
};


const dayOfWeekNames = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];
function renderDateCell(cellData) {
  alert("Called");
  return (
    <React.Fragment>
      <div>{dayOfWeekNames[cellData.date.getDay()]}</div>
      <div>{cellData.date.getDate()}</div>
    </React.Fragment>
  );
}

const Appointment = ({ children, style, onClick, ...restProps }) => {
  const value = { ...restProps };

  return (
    <Appointments.Appointment
      className={value.data.id === 1 ? "anime" : ""}
      {...restProps}
      onClick={(e) => {
        if (e.data.id === 1) {
          window.redcomp.onHistory();
        }
      }}
      style={{
        ...style,
        borderRadius: "0px",
        width: "120px",
        fontSize: "11px",
        color: "black !important",
      }}
    >
      {children}
    </Appointments.Appointment>
  );
};

export class Calender extends React.Component {
  constructor(props) {
    super(props);
    window.redcomp = this;
    this.state = {
      bannerType: null,
      drugType: null,
      value: new Date(),
      open: false,
      refresh: false,
      resources: [
        {
          fieldName: "id",
          title: "title",
          instances: appointments,
        },
      ],
    };
    this.adConfig = localStorage.getItem("creativeConfig") ? JSON.parse(localStorage.getItem("creativeConfig")) : null;
    this.showAd = this.adConfig && this.adConfig.workflowWithAdds ? this.adConfig.workflowWithAdds.includes("Calendar/Waiting Room") : false;

    this.onChange = this.onChange.bind(this);

    if (!verifyAuth()) {
      this.props.history.push({
        pathname: "/",
      });
    }
  }

  getDrugToShow() {
    if (!this.adConfig) return;
    const withCta = this.adConfig ? this.adConfig.creative_cta === "With CTAs" : null;

    // check all present
    const allPresent = creativeConstants.messaging_sparks.every((element) => this.adConfig.messaging_sparks.includes(element));
    if (allPresent) return withCta ? NEW_AD_CREATIVE.CARE_DURA : NEW_AD_CREATIVE.CARE_DURA_NO_CTA

    // if any of rep or sample and copay
    const isPainfin = ['Rep', 'Copay'].every((element) => this.adConfig.messaging_sparks.includes(element)) || ['Sample', 'Copay'].every((element) => this.adConfig.messaging_sparks.includes(element));
    if (isPainfin) return withCta ? NEW_AD_CREATIVE.PAINFIN : NEW_AD_CREATIVE.PAINFIN_NO_CTA;

    // if drug, trail and copay all 3 present
    const isScleroderma = ['Drug', 'Trial', 'Copay'].every((element) => this.adConfig.messaging_sparks.includes(element));
    if (isScleroderma) return withCta ? NEW_AD_CREATIVE.SCLERODERMA : NEW_AD_CREATIVE.SCLERODERMA_NO_CTA;

    // if only clinical and copay
    const isCareDura = ['Drug', 'Copay'].every((element) => this.adConfig.messaging_sparks.includes(element));
    if (isCareDura) return withCta ? NEW_AD_CREATIVE.CARE_DURA : NEW_AD_CREATIVE.CARE_DURA_NO_CTA

    return withCta ? NEW_AD_CREATIVE.CARE_DURA : NEW_AD_CREATIVE.CARE_DURA_NO_CTA
  }

  getBannerType() {
    const len = this.adConfig ? this.adConfig.creative_size.length : 0;
    if (len === 0) return null;
    const newRandValue = Math.floor(Math.random() * len);
    return this.adConfig.creative_size[newRandValue];
  };
  componentDidMount() {
    let toSetBannerType = this.getBannerType();
    let drugType = this.getDrugToShow();
    //while( this.adConfig && toSetBannerType === 'react' && (this.adConfig.creative_size.includes('vertical') || this.adConfig.creative_size.includes('horizontal'))) toSetBannerType = this.getBannerType();
    this.setState({ ...this.state, bannerType: toSetBannerType, drugType: drugType });
  }

  onChange = () => {
    this.state.value = this.state.value + 1;
  };

  onHistory = () => {
    this.props.history.push({
      pathname: "/People/dashboard",
    });
  };

  handleClosePopup = () => {
    this.adConfig = localStorage.getItem("creativeConfig") ? JSON.parse(localStorage.getItem("creativeConfig")) : null;
    let drugType = this.getDrugToShow();
    let toSetBannerType = this.getBannerType();
    this.setState({ ...this.state, open: false, drugType: drugType, bannerType: toSetBannerType });
  };
  static contextType = Mycontext;

  render() {
    const randValue = parseInt(window.sessionStorage.getItem("rValue"));
    const getRandomVertCreative = () => {
      const withCta = this.adConfig.creative_cta === "With CTAs";

      if (withCta) {
        if (randValue === 1) {
          if (this.adConfig.messaging_sparks.includes("Rep"))
            return htmls.MedizenVertAddWithCTARep;
          if (this.adConfig.messaging_sparks.includes("Sample"))
            return htmls.MedizenVertAddWithCTASample;
          return htmls.MedizenVertAddWithCta;
        }
        if (randValue === 2) {
          if (this.adConfig.messaging_sparks.includes("Sample"))
            return htmls.PrimeraVertAddWithCTASample;
          if (this.adConfig.messaging_sparks.includes("Rep"))
            return htmls.PrimeraVertAddWithCTARep;
          return htmls.PrimeraVertAddWithCTA;
        }
        if (randValue === 3) {
          if (this.adConfig.messaging_sparks.includes("Rep"))
            return htmls.PanazVertAddWithCTARep;
          if (this.adConfig.messaging_sparks.includes("Sample"))
            return htmls.PanazVertAddWithCTASample;
          return htmls.PanazVertAddWithCta;
        }
      } else {
        if (randValue === 1) {
          if (this.adConfig.messaging_sparks.includes("Sample"))
            return htmls.MedizenVertAddWithoutCTASample;
          if (this.adConfig.messaging_sparks.includes("Rep"))
            return htmls.MedizenVertAddWithoutCTARep;
          return htmls.MedizenVertAddWithoutCTA;
        }
        if (randValue === 2) {
          if (this.adConfig.messaging_sparks.includes("Rep"))
            return htmls.PrimeraVertAddWithoutCTARep;
          if (this.adConfig.messaging_sparks.includes("Sample"))
            return htmls.PrimeraVertAddWithoutCTASample;
          return htmls.PrimeraVertAddWithoutCTA;
        }
        if (randValue === 3) {
          if (this.adConfig.messaging_sparks.includes("Sample"))
            return htmls.PanazVertAddWithoutCTASample;
          if (this.adConfig.messaging_sparks.includes("Rep"))
            return htmls.PanazVertAddWithoutCTARep;
          return htmls.PanazVertAddWithoutCTA;
        }
      }
    };

    return (
      <>
        <MobileNavbar />
        <GridDashBoard>
          <div>
            <Logo2 />
            <div className="noneAll">
              <Navbar Heading="Calendar" handleSettingClick={() => this.setState({ ...this.state, open: true })} />
            </div>
            <div className="desk-visibility">
              <Sidebar config={sidebarConfig} />
            </div>
          </div>
          <div style={{ width: "100%" }} className="customeGridArea">
            <div className="conatiner hideMainIcon">
              <Navbar Heading="Calendar" handleSettingClick={() => this.setState({ ...this.state, open: true })} />
              <CustomDiv className="text-center">
                <div key={this.state.drugType} className="ver-wrapper iframeImageSection" style={{ marginTop: "20px" }}>
                  {this.state.bannerType === "horizontal" &&
                    this.showAd &&
                    this.state.drugType && (
                      <div style={{ maxWidth: '728px', maxHeight: '90px', margin: '0 auto' }}>
                        <iframe
                          title="iframe"
                          srcDoc={
                            NEW_CREATIVE_LOCATION[this.state.drugType].horizontal
                          }
                          style={{
                            width: '100%',
                            height: '100%',
                            maxWidth: '728px',
                            maxHeight: '90px'
                          }}
                          frameBorder="0"
                          scrolling="no"
                        />
                      </div>
                    )}
                </div>
              </CustomDiv>
              <Grid container style={{ overflow: "hidden" }}>
                <Grid className="sectionCalender" item lg={`${this.state.bannerType === "vertical" ? "9" : "12"}`} md={12}>
                  <CustomDiv
                    style={{
                      marginTop: 20,
                      marginLeft: "22.5%",
                      fontWeight: 650,
                      fontSize: 16.1,
                      color: "#57585C",
                    }}
                  >
                    <b> {moment().format("MMMM, DD, YYYY")}</b>
                    <b
                      style={{
                        marginLeft: "15px",
                        fontSize: 20,
                        fontWeight: 450,
                      }}
                    >
                      {" "}
                      ‹ ›
                    </b>
                  </CustomDiv>
                  <CalenderConatainer id="customeCalender">
                    <Grid container className="calenderBlock">
                      <Grid item lg={3} md={3} xs={12} sm={12}>
                        <CustomCalender
                          calendarType={"US"}
                          onChange={this.onChange}
                          value={this.state.value}
                        />{" "}
                        {this.state.drugType && this.state.bannerType === "react" && this.showAd && (

                          <div style={{ marginBottom: "20px" }} className="mobileCss mobCenter squ-wrapper">
                            <div className="responsiveMargin" style={{ maxWidth: '300px', minHeight: '250px', }}>
                              <iframe
                                title="iframe"
                                srcDoc={NEW_CREATIVE_LOCATION[this.state.drugType].square}
                                style={{
                                  width: '100%',
                                  height: '100%',
                                  maxWidth: '300px',
                                  minHeight: '250px'
                                }}
                                frameBorder="0"
                                scrolling="no"
                              />
                            </div>
                          </div>
                        )}
                      </Grid>
                      <Grid item className="calenderSection" lg={9} md={9} xs={12} sm={12} style={{ paddingLeft: "15px", paddingRight: "25px" }}>
                        <CustomPaper>
                          <Scheduler
                            data={appointments}
                            height={600}
                            showAllDayPanel={false}
                            dateCellRender={renderDateCell}
                          >
                            <WeekView startDayHour={13} endDayHour={18} />
                            <Appointments appointmentComponent={Appointment} />
                            <Resources
                              data={this.state.resources}
                              mainResourceName="id"
                            />
                          </Scheduler>
                        </CustomPaper>
                      </Grid>
                    </Grid>
                  </CalenderConatainer>
                </Grid>
                {
                  this.state.drugType && this.state.bannerType === "vertical" && this.showAd && (
                    <Grid item lg={`${this.state.bannerType === "vertical" ? "3" : ""}`} md={12} className="mt-60 mobileCss mobCenter" >
                      <div style={{ marginBottom: "200px", textAlign: "right" }} className="mobileCss mobCenter  d-flex justify-content-end">
                        <div className='responsiveMargin' style={{ maxWidth: '300px', minHeight: '600px', }}>
                          <iframe
                            title="iframe"
                            srcDoc={NEW_CREATIVE_LOCATION[this.state.drugType].vertical}
                            style={{
                              width: '100%',
                              height: '100%',
                              maxWidth: '100%',
                              minHeight: '600px',
                              marginBottom: "30px"
                            }}
                            frameBorder="0"
                            scrolling="no"
                          />
                        </div>
                      </div>
                    </Grid>
                  )
                }
              </Grid>
              {this.state.open && <CustomizePopup open={this.state.open} onClose={this.handleClosePopup} />}
            </div>
          </div>
        </GridDashBoard>
      </>
    );
  }
}
